import * as Borders from 'src/theme/borders';
import * as Shadows from 'src/theme/shadows';

export default {
  paper: {
    border: Borders.GrayThinBorder,
    boxShadow: Shadows.DropdownMenuShadow,
  },
  list: {
    padding: '4px 0',
  },
};
